import { Cashier } from '@shared/app/scripts/services/cashier';

export class CashierManager {
  list = [];
  loaded = false;

  constructor(private cashier: Cashier) {}

  init = () => {
    return this.cashier
      .filter(
        {
          $or: [
            {
              active: {
                $exists: false,
              },
            },
            {
              active: true,
            },
          ],
        },
        0,
        1000,
      )
      .then((data) => {
        if (data.length === 0) {
          throw new Error('Failed to initialized cashiers');
        }

        this.loaded = true;
        this.list = data;

        return data;
      });
  };
}

/*
 * Service cashierManager
 */
angular.module('posApp').factory('cashierManager', (cashier: Cashier) => {
  return new CashierManager(cashier);
});
